//
//
//
(function ($, window, document) {
	//
	//
	//
	$(function () {
		//
		//

		const mfp_image_block = $(
			".wp-block-image:not(.wp-block-gallery .wp-block-image).js__magnific:not(.video)"
		);
		const mfp_video_block = $(
			".wp-block-image:not(.wp-block-gallery .wp-block-image).js__magnific.video"
		);

		mfp_video_block.each(function () {
			$(this).magnificPopup({
				delegate: "a",
				type: "iframe",
			});
		});

		//
		//
		mfp_image_block.each(function () {
			$(this).magnificPopup({
				delegate: "a",
				type: "image",
			});
		});
		//

		//
	});
})(window.jQuery, window, document);
